<template>
  <v-dialog value="true" fullscreen hide-overlay persistent>
    <v-card tile flat color="#fff" elevation="0">
      <documentos-compra-direta-cabecalho
          :numeroProcesso="resumoCompraDireta.processo"
          :orgao="resumoCompraDireta.orgao"
          @voltar="tratarEventoDeVoltar"/>

      <v-divider style="margin-left: 20px; margin-right: 20px; margin-bottom: 20px;"></v-divider>

      <div class="v-card__text mt-3">
        <p v-if="documentosVirtualizados.length === 0"
           class="mensagem-quando-vazio">
          Não foi possível carregar os relatórios da compra direta.
        </p>

                <painel-documentos-tabela-todos
                    :documentos="documentosVirtualizados"
                    :operacaoExecutadaComSucesso="operacaoExecutadaComSucesso"
                    @baixarDocumentoEmLote="processarEventoBaixarEmLote"
                    @juntarDocumentosEmLote="processarEventoJuntarEmLote"
                    @assinarDocumentosEmLote="processarEventoIniciarAssinarEmLote"
                    @baixarDocumento="tratarEventoDownload"
                    @juntarDocumento="juntarDocumento"
                    @virtualizarDocumento="virtualizarDocumentoCompraDireta"
                    @desentranharDocumento="processarEventoDesentranharDocumento"
                    @redigirDocumento="processarEventoRedigirDocumento"
                    @reordenarDocumento="processarEventoReordenarDocumento"
                    @cancelarDocumento="processarEventoCancelarDocumento"
                    @documentoSincronizado="processarEventoDocumentoSincronizado"
                    @acessarTermoDesentranhamento="processarEventoAcessarTermoDesentranhamento"/>
            </div>
        </v-card>
        <modal-enviar-motivo-justificativa key="global-motivo-justificativa-provider"
                                           com-botao-cancelar
                                           com-botao-confirmar
                                           texto-botao-confirmar="Confirmar"
                                           :ilustracao="{ label1: 'Documento', texto1: documentoSelecionado.nome }"
                                           :deveMostrarModalMotivoJustificativa="deveMostrarModalMotivoJustificativa"
                                           titulo="Motivo de cancelamento"
                                           @confirmar="processarCancelamentoDocumento"
                                           @cancelar="fecharModalMotivoDevolucao"/>

    <modal-confirmacao-assinatura-em-lote v-model="dadosConfirmacaoAssinaturas"
                                          :deveMostrarModalConfirmacaoAssinaturas="deveMostrarModalConfirmacaoAssinaturas"
                                          @confirmaAssinaturas="processarEventoFinalizarAssinarEmLote"
                                          @fecharModalConfirmacaoAssinaturas="processarEventoCancelarFinalizacaoAssinarEmLote"/>

    <c-d-loading-progress :is-loading="habilitarLoading" mensagem="Processando assinaturas em lote..."/>

    <modal-reordenacao-documento :deve-mostar-modal-reordenacao="deveMostarModalReordenacao"
                                 :documento="documentoReordenar"
                                 :sequencias="sequencias"
                                 @eventoReordenarDocumento="executarOperacaoReordenar"
                                 @eventoFecharModalReordenacao="fecharModalReordenacao"/>
  </v-dialog>
</template>

<script>
import {mapState} from 'vuex'
import DocumentosCompraDiretaCabecalho from './cabecalho/DocumentosCompraDiretaCabecalho'
import {actionTypes, mutationTypes} from '@/core/constants'
import PainelDocumentosTabelaTodos from './painel-documentos/PainelDocumentosTabelaTodos'
import ModalConfirmacaoAssinaturaEmLote from './components/ModalConfirmacaoAssinaturaEmLote'
import CDLoadingProgress from '@/views/pages/commons/loading/CDLoadingProgress'
import ModalReordenacaoDocumento from './components/ModalReordenacaoDocumento'
import ModalEnviarMotivoJustificativa from '@/views/components/ModalEnviarMotivoJustificativa'

export default {
    name: 'DocumentosCompraDiretaVirtualizada',
    components: {
        ModalReordenacaoDocumento,
        ModalEnviarMotivoJustificativa,
        CDLoadingProgress,
        ModalConfirmacaoAssinaturaEmLote,
        PainelDocumentosTabelaTodos,
        DocumentosCompraDiretaCabecalho
    },
    data() {
        return {
            compraDiretaId: null,
            url: null,
            documentosVirtualizados: [],
            ehOpcaoJuntados: false,
            deveMostrarModalConfirmacaoAssinaturas: false,
            operacaoExecutadaComSucesso: false,
            dadosConfirmacaoAssinaturas:{},
            habilitarLoading: false,
            documentoReordenar: {},
            sequencias: [],
            deveMostarModalReordenacao: false,
            documentoSelecionado: {},
            deveMostrarModalMotivoJustificativa: false
        }
    },
    computed: {
        ...mapState(['resumoCompraDireta', 'loki', 'parametros']),
        idCompraAtivo() {
            const fromRoute = this.compraDiretaId ? Number(this.compraDiretaId) : null
            const fromResumo = this.resumoCompraDireta?.id ? Number(this.resumoCompraDireta.id) : null
            const choose = fromRoute ?? fromResumo
            return Number.isFinite(choose) ? choose : null
        }
    },
    async mounted() {
        this.setCompraDiretaId()
        if (!this.idCompraAtivo) {
            await this.buscarResumoDaCompraDireta()
        }
    },
    methods: {
        setCompraDiretaId() {
            const raw = this.$route?.params?.id ?? null
            const num = raw !== null ? Number(raw) : null
            this.compraDiretaId = Number.isFinite(num) ? num : null
        },

        tratarEventoDeVoltar() {
            this.$router.push({ name: 'Resultado', params: { id: this.idCompraAtivo } })
        },

        async buscarSituacaoEdocs() {
            if (!this.parametros?.propriedadesCompraDiretas) return
            const props = this.parametros.propriedadesCompraDiretas
            const edocsAtivo = props.integration?.edocs?.ativo
            const identidadeES = props.identidadeCliente === 'ES'
            if (!(identidadeES && edocsAtivo)) return
            const compraId = this.idCompraAtivo
            if (typeof compraId !== 'number' || !Number.isFinite(compraId)) {
                return
            }

            try {
                await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_SITUACAO_DOCUMENTOS_EDOCS, this.idCompraAtivo)
            } catch (err) {
                this.mostrarNotificacaoErro(err.message)
            }
        },

        async buscarDocumentosVirtualizados() {
            if (!this.idCompraAtivo) return

            try {
                const response = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_DOCUMENTOS_VIRTUALIZADOS, this.idCompraAtivo)
                this.documentosVirtualizados = Array.isArray(response?.documentos) ? response.documentos : []
                this.sequencias = Array.isArray(response?.sequencias) ? response.sequencias : []
            } catch (err) {
                this.mostrarNotificacaoErro(err.message)
                this.documentosVirtualizados = []
                this.sequencias = []
            }
        },

        async buscarResumoDaCompraDireta() {
            if (!this.idCompraAtivo) return
            try {
                await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, this.idCompraAtivo)
            } catch (err) {
                this.mostrarNotificacaoErro(err.message)
            }
        },
        async tratarEventoDownload(documento, tipoDownload) {
            const compraId = this.idCompraAtivo
            if (!compraId) return

            const objetoDownload = {
                idVirtualizado: documento.documentoVirtualizadoId,
                opcaoDownloadVirtualizacao: tipoDownload,
                compraDiretaId: compraId,
                nomeArquivo: documento.nome,
                noProcessoDigital: documento.noProcessoDigital,
                uri: documento.documentoVirtualizadoId == null ? documento.uriFileManager : null,
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_DOCUMENTO_COMPRA_DIRETA, objetoDownload)
        },

        async virtualizarDocumentoCompraDireta(documento) {
            const compraId = this.idCompraAtivo
            if (!compraId) return

            const objetoVirtualizar = {
                compraDiretaId: compraId,
                tipoDocumento: documento.tipo
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.VIRTUALIZAR_DOCUMENTO_COMPRA_DIRETA, objetoVirtualizar)
            this.mostrarNotificacaoSucesso && this.mostrarNotificacaoSucesso('Documento virtualizado com sucesso!')
            await this.buscarDocumentosVirtualizados()
        },

        async juntarDocumento(documento) {
            const compraId = this.idCompraAtivo
            if (!compraId) return

            const objetoJuntar = {
                pessoaId: documento.fornecedorId,
                compraDiretaId: compraId,
                tipoDocumento: documento.tipo,
                documentoId: documento.documentoId,
                documentoVirtualizadoId: documento.documentoVirtualizadoId,
            }
            const resp = await this.$store.dispatch(actionTypes.COMPRADOR.JUNTAR_DOCUMENTO_COMPRA_DIRETA, objetoJuntar)
            if (resp && resp.juntadoComSucesso === true) {
                this.mostrarNotificacaoSucesso && this.mostrarNotificacaoSucesso('Documento juntado com sucesso!')
                await this.buscarDocumentosVirtualizados()
            } else {
                throw new Error('Ocorreu um erro ao juntar o documento.')
            }
        },

        async processarEventoBaixarEmLote(documentosSelecionados) {
            this.operacaoExecutadaComSucesso = false
            if (documentosSelecionados.length > 0) {
                const compraId = this.idCompraAtivo
                if (!compraId) throw new Error('compraDiretaId inválido')

                const dadosDocumentos = documentosSelecionados.map(doc => ({
                    compraDiretaId: compraId,
                    nome: doc.nome,
                    documentoVirtualizadoId: doc.documentoVirtualizadoId,
                    documentoId: doc.documentoId,
                    tipo: doc.tipo,
                    noProcessoDigital: doc.noProcessoDigital,
                    fornecedorId: doc.fornecedorId,
                    uriFileManager: doc.uriFileManager
                }))

                await this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_DOCUMENTOS_EM_LOTE, dadosDocumentos)
                this.operacaoExecutadaComSucesso = true
            }
            else {
                this.operacaoExecutadaComSucesso = false
                throw new Error('É necessário selecionar ao menos um documento.')
            }
        },

        async processarEventoJuntarEmLote(documentosSelecionados) {
            this.operacaoExecutadaComSucesso = false
            if (documentosSelecionados.length > 0) {

                this.filtarDocumentosJaJuntados(documentosSelecionados)

                const compraId = this.idCompraAtivo
                if (!compraId) throw new Error('compraDiretaId inválido')

                const dadosDocumentos = documentosSelecionados.map(doc => ({
                    compraDiretaId: compraId,
                    nome: doc.nome,
                    documentoVirtualizadoId: doc.documentoVirtualizadoId,
                    documentoId: doc.documentoId,
                    tipo: doc.tipo,
                    noProcessoDigital: doc.noProcessoDigital,
                    fornecedorId: doc.fornecedorId,
                    uriFileManager: doc.uriFileManager,
                    juntado: doc.juntado
                }))

                const resposta = await this.$store.dispatch(actionTypes.COMPRADOR.JUNTAR_DOCUMENTOS_EM_LOTE, dadosDocumentos)

                if (resposta && resposta.successful === true) {
                    this.operacaoExecutadaComSucesso = true
                    this.mostrarNotificacaoSucesso && this.mostrarNotificacaoSucesso('Documentos juntados com sucesso!')
                    await this.buscarDocumentosVirtualizados()
                } else {
                    this.operacaoExecutadaComSucesso = false
                    throw new Error('Ocorreu um erro ao juntar os documentos.')
                }
            } else {
                this.operacaoExecutadaComSucesso = false
                throw new Error('É necessário selecionar ao menos um documento.')
            }
        },

        async processarEventoIniciarAssinarEmLote(documentosSelecionados) {
            this.operacaoExecutadaComSucesso = false
            if (documentosSelecionados.length > 0) {

                this.filtarDocumentosJaJuntados(documentosSelecionados)

                const documentos = documentosSelecionados.map(doc => ({
                    compraDiretaId: this.idCompraAtivo,
                    nome: doc.nome,
                    documentoVirtualizadoId: doc.documentoVirtualizadoId,
                    documentoId: doc.documentoId,
                    tipo: doc.tipo,
                    noProcessoDigital: doc.noProcessoDigital,
                    fornecedorId: doc.fornecedorId,
                    uriFileManager: doc.uriFileManager,
                    juntado: doc.juntado,
                    assinado: doc.assinado
                }))

                const userId = this.loki && this.loki.user && this.loki.user.id ? this.loki.user.id : null
                if (!userId) throw new Error('Usuário inválido para iniciar assinatura.')

                const dadosRequisicao = {
                    compraDiretaId: this.idCompraAtivo,
                    usuarioId: userId,
                    documentos: documentos
                }

                this.dadosConfirmacaoAssinaturas = await this.$store.dispatch(actionTypes.COMPRADOR.INICIAR_ASSINATURA_DOCUMENTOS_EM_LOTE, dadosRequisicao)

                if (this.dadosConfirmacaoAssinaturas && this.dadosConfirmacaoAssinaturas.iniciadoComSucesso === true) {
                    this.deveMostrarModalConfirmacaoAssinaturas = true
                } else {
                    this.operacaoExecutadaComSucesso = false
                    throw new Error('Ocorreu um erro no processamento da assinatura, por gentileza, contacte o suporte.')
                }
            } else {
                this.operacaoExecutadaComSucesso = false
                throw new Error('É necessário selecionar ao menos um documento.')
            }
        },

        async processarEventoFinalizarAssinarEmLote() {
            this.operacaoExecutadaComSucesso = false

            const userId = this.loki && this.loki.user && this.loki.user.id ? this.loki.user.id : null
            if (!userId) throw new Error('Usuário inválido para finalizar assinatura.')

            const dadosFinalizarAssinaturas = {
                compraDiretaId: this.idCompraAtivo,
                usuarioId: userId,
                assinaturaLoteId: this.dadosConfirmacaoAssinaturas.assinaturaLoteId,
                codigoConfirmacao: this.dadosConfirmacaoAssinaturas.codigoConfirmacao
            }

            this.deveMostrarModalConfirmacaoAssinaturas = false
            const resposta = await this.$store.dispatch(actionTypes.COMPRADOR.FINALIZAR_ASSINATURA_DOCUMENTOS_EM_LOTE, dadosFinalizarAssinaturas)

            this.habilitarLoading = true

            if (resposta && resposta.finalizadoComSucesso === true) {
                this.operacaoExecutadaComSucesso = true

                setTimeout(async () => {
                    await this.buscarDocumentosVirtualizados()
                    this.habilitarLoading = false
                    this.mostrarNotificacaoSucesso && this.mostrarNotificacaoSucesso('Documentos assinados com sucesso!')
                }, 5000)

            } else {
                this.habilitarLoading = false
                this.operacaoExecutadaComSucesso = false
                throw new Error('Ocorreu um erro no processamento da assinatura, por gentileza, contacte o suporte.')
            }
        },

        processarEventoCancelarFinalizacaoAssinarEmLote(){
            this.operacaoExecutadaComSucesso = false
            this.deveMostrarModalConfirmacaoAssinaturas = false
            this.dadosConfirmacaoAssinaturas = {}
        },

        filtarDocumentosJaJuntados(documentosSelecionados){
            const documentosJaJuntados = documentosSelecionados.filter(doc => doc.juntado === true)
            if(documentosJaJuntados.length > 0)
                throw new Error('Os documentos ['+ documentosJaJuntados.map(doc => doc.nome).join('; ') +'] já estão juntados ao processo.')
        },
        async processarEventoDesentranharDocumento(documento) {
            try {
                const inputData = {
                    compraDiretaId: this.compraDiretaId,
                    documentoId: documento.documentoId,
                    tipoDocumento: documento.tipo
                }

                const response = await this.$store.dispatch(actionTypes.COMPRADOR.DESENTRANHAR_DOCUMENTO_VIRTUALIZADOV2, inputData)

                if (response && response.documento && response.documento.id) {
                    const termoId = response.documento.id

                    await this.$router.push({
                        name: 'TermoDesentranhamento',
                        params: {
                            idTermo: termoId
                        }
                    })
                }
            } catch (e) {
                this.mostrarNotificacaoErro(e.message)
            }
        },
        async processarEventoRedigirDocumento(documento) {
            try {
                await this.$router.push({
                    name: 'TermoDesentranhamento',
                    params: {
                        idTermo: documento.documentoId
                    }
                })
            } catch (error) {
                this.mostrarNotificacaoErro(error.message || 'Erro ao acessar documento para edição')
            }
        },

        processarEventoReordenarDocumento(documento) {
            this.documentoReordenar = documento
            this.deveMostarModalReordenacao = true
        },

        async executarOperacaoReordenar(novaSequencia) {
            const{ documentoVirtualizadoId, documentoId, fornecedorId, tipo } = this.documentoReordenar
            const requestData = {
                compraDiretaId: this.idCompraAtivo,
                documentoVirtualizadoId,
                tipo,
                documentoId,
                fornecedorId,
                novaSequencia
            }
            const response = await this.$store.dispatch(actionTypes.COMPRADOR.REORDENAR_DOCUMENTO_VIRTUALIZADO, requestData)

            if(response && response.id) {
                this.documentoReordenar.numeroSequencial = response.numeroSequencial
                this.documentoReordenar.primeiraPagina = response.primeiraPagina
                this.documentoReordenar.ultimaPagina = response.ultimaPagina

                this.mostrarNotificacaoSucesso && this.mostrarNotificacaoSucesso('Documento reordenado com sucesso!')
                this.fecharModalReordenacao()
            }
            else {
                this.mostrarNotificacaoErro && this.mostrarNotificacaoErro('Erro ao reordenar o documento.')
            }
        },

        fecharModalReordenacao() {
            this.deveMostarModalReordenacao = false
            this.documentoReordenar = {}
        },

        processarEventoCancelarDocumento(documento) {
            this.documentoSelecionado = documento
            this.deveMostrarModalMotivoJustificativa = true
        },

        async processarCancelamentoDocumento(motivo) {
            const compraId = this.idCompraAtivo
            if (!compraId) throw new Error('compraDiretaId inválido')

            const dados = {
                compraDiretaId: compraId,
                documentoId: this.documentoSelecionado.documentoId,
                documentoVirtualizadoId: this.documentoSelecionado.documentoVirtualizadoId,
                tipo: this.documentoSelecionado.tipo,
                motivoCancelamento: motivo
            }

            await this.$store.dispatch(actionTypes.COMPRADOR.CANCELAMENTO_DOCUMENTO_VIRTUALIZADO, dados)
            this.mostrarNotificacaoSucessoDefault && this.mostrarNotificacaoSucessoDefault()
            this.fecharModalMotivoDevolucao()
        },

        fecharModalMotivoDevolucao() {
            this.documentoSelecionado = {}
            this.deveMostrarModalMotivoJustificativa = false
        },
        async processarEventoDocumentoSincronizado(evento) {
            try {
                this.mostrarNotificacaoSucesso(evento.mensagem || 'Documento sincronizado com sucesso!')
                await this.buscarDocumentosVirtualizados()
            } catch (e) {
                this.mostrarNotificacaoErro(e.message || 'Erro ao atualizar lista de documentos')
            }
        },
        async processarEventoAcessarTermoDesentranhamento(documento) {
            try {
                const termoDesentranhamento = await this.$store.dispatch(
                    actionTypes.COMPRADOR.BUSCAR_DOCUMENTO_POR_REFERENCIA_DESENTRANHAMENTO,
                    documento.documentoVirtualizadoId
                )

                if (termoDesentranhamento && termoDesentranhamento.id) {
                    await this.$router.push({
                        name: 'TermoDesentranhamento',
                        params: {
                            idTermo: termoDesentranhamento.id
                        }
                    })
                } else {
                    this.mostrarNotificacaoErro('Termo de desentranhamento não encontrado')
                }
            } catch (e) {
                this.mostrarNotificacaoErro(e.message || 'Erro ao buscar termo de desentranhamento')
            }
        }
    },

    watch: {
        idCompraAtivo: {
            handler(newVal) {
                if (newVal) {
                    this.buscarSituacaoEdocs()
                    this.buscarDocumentosVirtualizados()
                }
            },
            immediate: true
        }
    }
}
</script>
